import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { LoadingButton } from '@mui/lab';
import { Stack, Typography } from '@mui/material';

const DepartureAgentStep = ({ agents, busy, onSelect }) => {
  if (!agents.length) {
    return (
      <Typography color="text.secondary" textAlign="center" py={2}>
        انبارداری برای این عملیات ثبت نشده است.
      </Typography>
    );
  }

  return (
    <Stack gap={1.5} py={1}>
      {agents.map(agent => (
        <LoadingButton
          key={agent.guid || agent.operationAgentGuid}
          onClick={() => onSelect(agent)}
          disabled={busy}
          variant="contained"
          loading={busy}
          sx={{ minHeight: 48 }}
        >
          <PhoneAndroidIcon />
          {agent.name}
        </LoadingButton>
      ))}
    </Stack>
  );
};

export default DepartureAgentStep;
